import requests from "./httpService";
import getEmployeeId from "utils/commonAdmin";

 // <-- Add this line

const AdminServices = {
  // registerAdmin: async (body) => {
  //   return requests.post("/admin/register", body);
  // },
 
  // loginEmployee: async (body) => {
  //   return requests.post(`/employee/login`, body)
  // },

  // forgetPassword: async (body) => {
  //   return requests.put("/employee/forgot-password", body);
  // },

  // resetPassword: async (body) => {
  //   return requests.put("/employee/reset-password", body);
  // },

  // signUpWithProvider: async (body) => {
  //   return requests.post("/admin/signup", body);
  // },

  addStaff: async (body) => {
    return requests.post("/employee/add", body);
  },
  getAllStaff: async (body) => {
    return requests.get("/employee/", body);
  },
  getStaffById: async (id, body) => {
    return requests.get(`/employee/${id}`, body);
  },

  updateStaff: async (id, body) => {
    return requests.put(`/employee/update/${id}`, body);
  },

  updateStaffStatus: async (id, body) => {
    return requests.put(`/employee/status/${id}`, body);
  },

  deleteStaff: async (id) => {
    const id_employee =await getEmployeeId();
    return requests.delete(`/employee/delete/${id}/${id_employee}`);
  },
  getAllProfile: async () => {
    return requests.get("/profile/");
  },
  getAllState: async () => {
    return requests.get("/state/");
  },
  getAllStateCity: async () => {
    return requests.get("/city/getAllCityState/");
  },
};

export default AdminServices;
